import React, { PropsWithChildren, useContext } from 'react';

import { LogDataFormGroupProps, UnitNode } from '../../components';
import { BlockProps } from '../../editorComponents/Block/Block';

export interface BlockContextValue {
  setImpressionLogData?: (logData: UnitNode<BlockProps>) => LogDataFormGroupProps;
}

const BlockContext = React.createContext<BlockContextValue>({});
export const useBlockContext = () => useContext(BlockContext);

export function BlockContextProvider({
  children,
  value = {},
}: PropsWithChildren<{ value?: BlockContextValue }>) {
  return (
    <BlockContext.Provider value={value}>{ children }</BlockContext.Provider>
  );
}
